import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getMyPopularTractor, myPopularTractorApiUrl } from '../../../../api/user/queries/getMyPopularTractor';
import { IMyPopularTractor } from '../../../../interfaces/OwnTractor.interfaces';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';

export interface IUseGetMyPopularTractorParams {
  searchParam: {
    machineApprovalStatus: string;
    isPokeEnabled?: boolean;
  };
  options?: UseQueryOptions<IMyPopularTractor>;
}

export const useGetMyPopularTractor = ({ searchParam, options }: IUseGetMyPopularTractorParams) => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<IMyPopularTractor>(
    [
      myPopularTractorApiUrl,
      `machineApprovalStatus=${searchParam?.machineApprovalStatus}`,
      `isPokeEnabled=${searchParam?.isPokeEnabled ?? ''}`,
    ],
    () =>
      getMyPopularTractor({
        searchParam: {
          machineApprovalStatus: searchParam?.machineApprovalStatus,
          isPokeEnabled: searchParam?.isPokeEnabled,
        },
      }),
    { ...options, enabled: (options?.enabled ?? true) && isUserLoggedIn },
  );
};
